import {
    Icon,
    Modal,
    NestedDropdown,
    Notification,
    STATUS_TYPES,
    SearchableOptions,
    VALIDATION_PATTERNS,
    VALIDATORS,
    generateResolver,
    yup,
} from "dyl-components";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Checkbox, Form, Popup } from "semantic-ui-react";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import pbxConfigActions from "actions/pbx_config";
import { PhoneUtil } from "utils";
import FullScreenModalPopUp from "shared/FullScreenModalPopUp";
import CustomOptions from "../AddRingGroupOrCallQModal/subcomponents/customOptions";

const Content = ({ onClose, onReload, isEditing, onDirtyChange }) => {
    const LIMIT = 5;
    const PAGE = 1;

    const [extensionOptions, setExtensionOptions] = useState([]);
    const [destinationOptions, setDestinationOptions] = useState([]);
    const [emailBccOptions, setEmailBccOptions] = useState([]);
    const [displayedSounds, setDisplayedSounds] = useState([]);
    const [displayedHoldMusic, setDisplayedHoldMusic] = useState([]);
    const [search, setSearch] = useState("");
        const [listExtensionsFilters, setListExtensionsFilters] = useState({
            page: PAGE,
            offset: 0,
        });
    const [isSearchResultsVisible, setIsSearchResultsVisible] = useState(false);
const [users, setUsers] = useState({
        data: [],
        isOpen: false,
        count: 0,
    });

    const dispatch = useDispatch();

    const {
        companyVoicemail,
        conferenceRoom,
        parkingLot,
        extensionsList,
        count,
        isReadingExtensionsList,
        destinations,
        unusedExtensions,
        isReadingUnusedExtensions,
        isReadingDestinations,
        soundOptions
    } = useSelector((state) => state.pbx_config);

    const defaultValues = () => ({
        type: "company_voicemail",
        label: "",
        greeting_sound_id: 0,
        extension_number: null,
        vm_exit: null,
        vm_exit_parent: "",
        pin: "",
        email: [],
        display_view: false,
        sound_id: 0,
        users:[]
    });

    const companyVoicemailDefaultValues = () => ({
        type: "company_voicemail",
        label: companyVoicemail.label || "",
        greeting_sound_id: companyVoicemail?.greeting_sound?.sound_id || 0,
        extension_number: companyVoicemail.extension || null,
        vm_exit: companyVoicemail.vm_exit?.destination_id || null,
        vm_exit_parent: companyVoicemail.vm_exit?.type || "",
        pin: companyVoicemail.pin || "",
        email: companyVoicemail.email || [],
        display_view: companyVoicemail.display_view || false,
        users: companyVoicemail?.user_id?.map((ele)=>{return {text:ele?.username,value:ele?.id}}) || [],
        sound_id: 0,
    });

    const conferenceRoomDefaultValues = () => ({
        type: "conference_room",
        label: conferenceRoom.label || "",
        extension_number: conferenceRoom.extension || null,
        sound_id: conferenceRoom.sound?.sound_id || 0,
        display_view: conferenceRoom.view_display || false,
        greeting_sound_id: null,
        vm_exit: null,
        vm_exit_parent: "",
        pin: "",
        email: [],
    });


    const parkingLotDefaultValues = () => ({
        type: "parking_lot",
        label: parkingLot.label || "",
        extension_number: parkingLot.alias || null,
        sound_id: parkingLot.moh_sound?.sound_id || 0,
        display_view: parkingLot.view_display || false,
        greeting_sound_id: null,
        vm_exit: null,
        vm_exit_parent: "",
        pin: "",
        email: [],
    });

    const getDefaultValues = () => {
        switch (isEditing) {
            case "company_voicemail": {
                return companyVoicemailDefaultValues();
            }
            case "conference_room": {
                return conferenceRoomDefaultValues();
            }
            case "parking_lot": {
                return parkingLotDefaultValues();
            }
            default: {
                return defaultValues();
            }
        }
    };

    const searchFunction = async () => {
        callApiToGetContactOptions();
        setIsSearchResultsVisible(true);
        const updatedUsers = users.data?.map((ele)=>{
            getValues("users")?.forEach((user)=>{
                if(user.value === ele.user_id) {
                    ele.isSelected = true;
                }
            })
            return ele;
        })
        setUsers({
            ...users,
            data: updatedUsers,
            isOpen: true,
        });
    };

    const cancelFunction = async () => {
        setUsers({ data: [], isOpen: false });
        setSearch("");
        setIsSearchResultsVisible(false);
    };
    const checkSelectedContacts = (status, selected_contacts) => {
        const allContacts = [...users.data] || [];
        const selectedContacts = selected_contacts ?? getValues("users");
        allContacts.forEach((contact) => {
            if (!selectedContacts.length) contact.isSelected = false;
            selectedContacts.forEach((selected) => {
                if (selected.value === contact.user_id) {
                    contact.isSelected = status;
                }
            });
        });

        setUsers({ ...users, data: allContacts });
    };
    const callApiToGetContactOptions = () => {
        if (search.length >= 2) {
            const params = {
                search,
                page: PAGE,
                limit: LIMIT,
                active: true,
            };
            dispatch(pbxConfigActions.getListOfExtensions(params));
            setListExtensionsFilters({
                ...listExtensionsFilters,
                page: PAGE,
            });
        }
    };

    const {
        control,
        formState: { isValid, isDirty, errors },
        handleSubmit,
        watch,
        getValues,
        setError,
        setValue,
    } = useForm({
        mode: "onChange",
        defaultValues: getDefaultValues(),
        resolver: generateResolver({
            type: yup.string().required("This field is required"),
            label: VALIDATORS.TEAM_NAME().required("This field is required"),
            greeting_sound_id: yup.mixed().when("type", {
                is: (type) => type === "company_voicemail",
                then: schema => schema.required('This field is required'),
                otherwise: schema => schema.nullable(true),
            }),
            extension_number: yup.string().required("This field is required"),
            pin: VALIDATORS.PIN(),
            email: yup.array().of(VALIDATORS.EMAIL_ADDRESS()),
        }),
    });

    const watchedType = watch("type");

    const formatConferenceRoom = (data) => {
        const { label, display_view, sound_id, extension_number } = data;
        return {
            label,
            sound_id,
            view_display: display_view,
            extension: extension_number,
        };
    };

    const formatParkingLot = (data) => {
        const { label, display_view, sound_id, extension_number } = data;
        return {
            label,
            moh_sound_id: sound_id,
            view_display: display_view,
            alias: extension_number,
        };
    };

    const onAdd = async (data) => {
        const { type, greeting_sound_id, sound_id, users } = data;

        if (greeting_sound_id === 0) {
            delete data.greeting_sound_id;
        }
        if (sound_id === 0) {
            delete data.sound_id;
        }
        if( users.length > 0) {
            data.user_id = users.map(({ value }) => value);
            delete data.users;
        }

        try {
            switch (type) {
                case "company_voicemail": {
                    await dispatch(
                        pbxConfigActions.createCompanyVoicemails([data])
                    );
                    break;
                }
                case "conference_room": {
                    const payload = formatConferenceRoom(data);
                    await dispatch(
                        pbxConfigActions.createConferenceRoom(payload)
                    );
                    break;
                }
                case "parking_lot": {
                    const payload = formatParkingLot(data);
                    await dispatch(pbxConfigActions.createParkingLot(payload));
                    break;
                }
                default:
                    break;
            }
            onReload();
            onClose();
            Notification.alert(
                "Company Extension added successfully!",
                STATUS_TYPES.SUCCESS
            );
        } catch (e) {
            console.log(e);
            Notification.alert(
                "Failed to add Company Extension",
                STATUS_TYPES.ERROR
            );
        }
    };

    const onEdit = async (data) => {
        try {
            const { type } = data;
            switch (type) {
                case "company_voicemail": {
                    const { id } = companyVoicemail;
                    if(data.users.length > 0) {
                        data.user_id = data.users.map(({ value }) => value);
                        delete data.users;
                    }
                    await dispatch(
                        pbxConfigActions.updateCompanyVoicemail(id, data)
                    );
                    break;
                }
                case "conference_room": {
                    const { id } = conferenceRoom;
                    const payload = formatConferenceRoom(data);
                    await dispatch(
                        pbxConfigActions.updateConferenceRoom(id, payload)
                    );
                    break;
                }
                case "parking_lot": {
                    const { id } = parkingLot;
                    const payload = formatParkingLot(data);
                    await dispatch(
                        pbxConfigActions.updateParkingLot(id, payload)
                    );
                    break;
                }
                default:
                    break;
            }
            onReload();
            onClose();
            Notification.alert(
                "Company Extension updated successfully!",
                STATUS_TYPES.SUCCESS
            );
        } catch (e) {
            console.log(e);
            Notification.alert(
                "Failed to update Company Extension",
                STATUS_TYPES.ERROR
            );
        }
    };

    const onCheckDuplicatedName = async (originalLabel, isEditing) => {
        const label = getValues("label");
        try {
            if (!isEditing || (!!isEditing && originalLabel !== label)) {
                const isDuplicated = await dispatch(
                    pbxConfigActions.isDuplicatedName({
                        label,
                        type:
                            watchedType === "company_voicemail"
                                ? "vmbox"
                                : watchedType,
                    })
                );
                if (isDuplicated) {
                    setError("label", {
                        type: "unique",
                        message: "Name already exists!",
                    });
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const onLabelBlur = () => {
        switch (isEditing) {
            case "company_voicemail": {
                onCheckDuplicatedName(
                    companyVoicemail?.label || "",
                    !!isEditing
                );
                break;
            }
            case "conference_room": {
                onCheckDuplicatedName(conferenceRoom?.label || "", !!isEditing);
                break;
            }
            case "parking_lot": {
                onCheckDuplicatedName(parkingLot?.label || "", !!isEditing);
                break;
            }
            default:
                onCheckDuplicatedName("", false);
                break;
        }
    };

    const handleAdditionBcc = (_, { value }) => {
        setEmailBccOptions((prevOptions) => [
            {
                text: value,
                value: value,
                key: value,
                invalid: !VALIDATION_PATTERNS.email.test(value),
            },
            ...prevOptions,
        ]);
    };

    const renderLabel = (label) => {
        return {
            ...(!label.invalid ? {} : { className: "CompanyExtension--error" }),
            content: label.text,
        };
    };

    const getEditedExtension = (type) => {
        switch (type) {
            case "company_voicemail": {
                return companyVoicemail.extension;
            }
            case "conference_room": {
                return conferenceRoom.extension;
            }
            case "parking_lot": {
                return parkingLot.alias;
            }
            default:
                return null;
        }
    };

    useEffect(() => {
        if (destinations) {
            const destinationsAux = [...PhoneUtil.DESTINATION_TYPES_OPTIONS];
            const destinationOptionsAux = destinationsAux.map((destination) => {
                const { key } = destination;
                const options =
                    destinations[key]?.map(({ destination_id, label }) => ({
                        key: destination_id,
                        value: destination_id,
                        text: label,
                    })) || [];
                return { ...destination, options };
            });
            setDestinationOptions(destinationOptionsAux);
        }
    }, [destinations]);

    useEffect(() => {
        let lowerLimit = 0;
        let higherLimit = 0;
        switch (watchedType) {
            case "conference_room": {
                lowerLimit = 700;
                higherLimit = 799;
                break;
            }
            case "parking_lot": {
                lowerLimit = 600;
                higherLimit = 699;
                break;
            }
            default: {
                lowerLimit = 300;
                higherLimit = 399;
                break;
            }
        }
        const extensions = unusedExtensions
            .filter(
                (extension) =>
                    Number(extension) >= lowerLimit &&
                    Number(extension) <= higherLimit
            )
            .map((extension) => ({
                key: extension,
                value: extension,
                text: extension,
            }));
        const defaultExtension = extensions?.[0]?.value || null;
        if (isEditing) {
            const extension = getEditedExtension(isEditing);
            const fullExtensions = PhoneUtil.insertExtension(
                extension,
                extensions
            );
            setExtensionOptions(fullExtensions);
        } else {
            setValue("extension_number", defaultExtension);
            setExtensionOptions(extensions);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unusedExtensions]);

    useEffect(() => {
        dispatch(pbxConfigActions.getDestinations());
    }, [dispatch]);

    useEffect(() => {
        dispatch(
            pbxConfigActions.unusedExtensions({
                type: watchedType ? watchedType : "company_voicemail",
            })
        );
        dispatch(pbxConfigActions.getSoundOptions({
            category: watchedType ? watchedType === "conference_room" || watchedType === "parking_lot" ? "music" : watchedType : "company_voicemail"
        })
        );
    }, [watchedType, dispatch]);

    useEffect(() => {
            const formatedExtensionsOptions =
                extensionsList?.length &&
                extensionsList?.map(({ extension_number, id, user_id, user }) => {
                    let isSelected = false;
                    getValues("users")?.forEach((selected) => {
                        if (selected.value === user_id) {
                            isSelected = true;
                        }
                    });
                    return {
                        id,
                        name: extension_number,
                        user_id,
                        userName: `${user?.first_name || ""} ${
                            user?.last_name || ""
                        }`,
                        value: extension_number,
                        isSelected,
                    };
                });
            setUsers((prevUsers) => ({
                ...prevUsers,
                data: formatedExtensionsOptions || [],
                count: count,
            }));
        }, [extensionsList, getValues, count]);

    useEffect(() => {
        if (isEditing === "company_voicemail" && !!companyVoicemail) {
            const { email } = companyVoicemail;
            if (email && email.length > 0) {
                const emailOptions = email.map((mail) => ({
                    key: mail,
                    value: mail,
                    text: mail,
                    invalid: false,
                }));
                setEmailBccOptions(emailOptions);
            }
        }
    }, [isEditing, companyVoicemail]);

    useEffect(() => {
        if (soundOptions) {
            const { company_voicemail, music } = soundOptions
            const optionsAux = company_voicemail?.map(({ name, id }) => ({
                key: id,
                value: id,
                text: name
            })) || [];
            const holdOptions = music?.map(({ name, id }) => ({
                key: id,
                value: id,
                text: name
            })) || []
            setDisplayedSounds([{ key: 0, value: 0, text: "Default" }, ...optionsAux])
            setDisplayedHoldMusic([{ key: 0, value: 0, text: "Default" }, ...holdOptions])
        } else {
            setDisplayedSounds([]);
            setDisplayedHoldMusic([]);
        }
    }, [soundOptions]);

    useEffect(() => {
        if (onDirtyChange) {
            onDirtyChange(isDirty);
        }
        // eslint-disable-next-line
    }, [isDirty])


    return (
        <>
            <Modal.Header>
                {!!isEditing ? "Edit " : "Create "} Company Extension
            </Modal.Header>
            <Modal.Content>
                <Form noValidate loading={false}>
                    <div className="CompanyExtensionModal__form">
                        <div className="CompanyExtensionModal__controllerContainer">
                            <Controller
                                name="type"
                                control={control}
                                style={{ flex: 1 }}
                                render={({ field: { name, value, onChange }, fieldState: { error } }) => {
                                    return !!isEditing ? (
                                        <Form.Input
                                            name={name}
                                            value={PhoneUtil.COMPANY_EXTENSION_TYPES.find((extension_type) => value === extension_type.value).text}
                                            label="Type"
                                            required
                                            readOnly
                                        />
                                    ) : (
                                        <Form.Select
                                            name={name}
                                            value={value}
                                            onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                                            placeholder='Select extension type'
                                            options={PhoneUtil.COMPANY_EXTENSION_TYPES}
                                            label="Type"
                                            required
                                            error={error?.message}
                                            readOnly={!!isEditing}
                                        />
                                    )
                                }}
                            />
                            <Controller
                                name="label"
                                control={control}
                                style={{ flex: 1 }}
                                render={({
                                    field: { name, value, onChange },
                                    fieldState: { error },
                                }) => (
                                    <Form.Input
                                        name={name}
                                        value={value}
                                        onChange={(_, { value }) => {
                                            onChange({
                                                target: { name, value },
                                            });
                                        }}
                                        label="Name"
                                        placeholder="Type name"
                                        required
                                        error={error?.message}
                                        onBlur={onLabelBlur}
                                    />
                                )}
                            />
                        </div>
                        {watchedType === "company_voicemail" && (
                            <div
                                className="CompanyExtensionModal__controllerContainer"
                                style={{ marginBottom: 14 }}
                            >
                                <Controller
                                    name="greeting_sound_id"
                                    control={control}
                                    style={{ flex: 1 }}
                                    render={({
                                        field: { name, value, onChange },
                                        fieldState: { error },
                                    }) => (
                                        <Form.Select
                                            name={name}
                                            value={value}
                                            onChange={(_, { value }) => {
                                                onChange({
                                                    target: { name, value },
                                                });
                                            }}
                                            placeholder="Select VM greeting"
                                            options={displayedSounds}
                                            label="VM Greeting"
                                            required
                                            error={error?.message}
                                        />
                                    )}
                                />
                            </div>
                        )}
                        <div className="CompanyExtensionModal__controllerContainer">
                            <Controller
                                name="extension_number"
                                control={control}
                                style={{ flex: 1 }}
                                render={({ field: { name, value, onChange }, fieldState: { error } }) => {
                                    return !!isEditing ? (
                                        <Form.Input
                                            name={name}
                                            value={value}
                                            label="Extension"
                                            required
                                            readOnly
                                        />
                                    ) : (
                                        <Form.Select
                                            name={name}
                                            value={value}
                                            onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                                            placeholder='Select extension'
                                            options={extensionOptions}
                                            label="Extension"
                                            required
                                            error={error?.message}
                                            loading={isReadingUnusedExtensions}
                                        />
                                    )

                                }}
                            />
                            {watchedType !== "company_voicemail" && (
                                <Controller
                                    name="sound_id"
                                    control={control}
                                    style={{ flex: 1 }}
                                    render={({
                                        field: { name, value, onChange },
                                    }) => (
                                        <Form.Select
                                            name={name}
                                            value={value}
                                            onChange={(_, { value }) => {
                                                onChange({
                                                    target: { name, value },
                                                });
                                            }}
                                            placeholder="Select music on hold"
                                            options={displayedHoldMusic}
                                            label="Music On Hold"
                                        />
                                    )}
                                />
                            )}
                            {watchedType === "company_voicemail" && (
                                <Controller
                                    name="vm_exit_parent"
                                    control={control}
                                    render={({
                                        field: {
                                            name: parentName,
                                            value: parentValue,
                                            onChange: onParentChange,
                                        },
                                    }) => (
                                        <Controller
                                            name="vm_exit"
                                            control={control}
                                            render={({ field }) => {
                                                const {
                                                    name: childName,
                                                    value: childValue,
                                                    onChange: onChildChange,
                                                } = field;
                                                return (
                                                    <Form.Field
                                                        control={NestedDropdown}
                                                        child_value={childValue}
                                                        parent_value={
                                                            parentValue
                                                        }
                                                        loading={
                                                            isReadingDestinations
                                                        }
                                                        nested_options={
                                                            destinationOptions
                                                        }
                                                        onChange={(
                                                            _,
                                                            {
                                                                parent_value,
                                                                child_value,
                                                            }
                                                        ) => {
                                                            onParentChange({
                                                                target: {
                                                                    name: parentName,
                                                                    value: parent_value,
                                                                },
                                                            });
                                                            onChildChange({
                                                                target: {
                                                                    name: childName,
                                                                    value: child_value,
                                                                },
                                                            });
                                                        }}
                                                        placeholder="Select destination"
                                                        display_parent
                                                        selection
                                                        label={{
                                                            children: (
                                                                <span>
                                                                    VM Exit
                                                                    <Popup
                                                                        trigger={
                                                                            <Icon
                                                                                style={{
                                                                                    float: "right",
                                                                                    marginTop:
                                                                                        "0.25em",
                                                                                }}
                                                                                name="fas fa-info-circle"
                                                                                color="primary"
                                                                            />
                                                                        }
                                                                        inverted
                                                                        content="The caller is only routed to the selected destination if they press #9 during the voicemail and don’t leave a message."
                                                                    />
                                                                </span>
                                                            ),
                                                        }}
                                                        pointing="top"
                                                        className="CompanyExtensions__ruleField"
                                                    />
                                                );
                                            }}
                                        />
                                    )}
                                />
                            )}
                        </div>
                        {watchedType === "company_voicemail" && (
                            <div className="CompanyExtensionModal__controllerContainer">
                                <Controller
                                    name="pin"
                                    control={control}
                                    style={{ flex: 1 }}
                                    render={({
                                        field: { name, value, onChange },
                                        fieldState: { error },
                                    }) => (
                                        <Form.Input
                                            name={name}
                                            value={value}
                                            onChange={(_, { value }) => {
                                                onChange({
                                                    target: { name, value },
                                                });
                                            }}
                                            label="PIN"
                                            placeholder="Type PIN"
                                            error={error?.message}
                                        />
                                    )}
                                />
                                <Controller
                                    name="email"
                                    control={control}
                                    render={({
                                        field: { onChange, value, name },
                                        fieldState: { error },
                                    }) => (
                                        <Form.Dropdown
                                            className="CompanyExtensionsModal__emailField"
                                            label="Email"
                                            options={emailBccOptions}
                                            onChange={(
                                                _,
                                                { value: selected }
                                            ) => {
                                                onChange({
                                                    target: {
                                                        name: name,
                                                        value: selected,
                                                    },
                                                });
                                            }}
                                            selection
                                            fluid
                                            multiple
                                            allowAdditions
                                            search
                                            onAddItem={handleAdditionBcc}
                                            placeholder="Type email"
                                            value={value}
                                            renderLabel={renderLabel}
                                            error={
                                                error?.length
                                                    ? "Please remove invalid emails"
                                                    : false
                                            }
                                        />
                                    )}
                                />
                            </div>
                        )}
                        {watchedType === "company_voicemail" && (
                            <Form.Group className="extension-container">
                                <Controller
                                    name={`users`}
                                    control={control}
                                    render={({ field: { name, value, onChange } }) => {
                                        return (
                                            <SearchableOptions
                                                label="VM Box Access"
                                                loading={isReadingExtensionsList}
                                                search={search}
                                                searchFunction={searchFunction}
                                                cancelSearchFunction={cancelFunction}
                                                searchPlaceholder={
                                                    "Search extensions and users"
                                                }
                                                width={4}
                                                values={value}
                                                onChangeSearch={(_, { value }) => {
                                                    setIsSearchResultsVisible(false);
                                                    setSearch(value);
                                                }}
                                                onChangeSelected={(
                                                    _,
                                                    { value: removedContact }
                                                ) => {
                                                    checkSelectedContacts(false, [
                                                        removedContact,
                                                    ]);
                                                    onChange({
                                                        target: {
                                                            name,
                                                            value: value.filter(
                                                                (item) =>
                                                                    item !==
                                                                    removedContact
                                                            ),
                                                        },
                                                    });
                                                }}
                                                isSearchResultsVisible={
                                                    isSearchResultsVisible
                                                }
                                                renderSearchResults={
                                                    <CustomOptions
                                                        addClick={(extension) => {
                                                            onChange({
                                                                target: {
                                                                    name,
                                                                    value: [
                                                                        extension,
                                                                        ...value
                                                                    ],
                                                                },
                                                            });
                                                            checkSelectedContacts(true);
                                                        }}
                                                        contactsList={users?.data?.map((user)=>{
                                                            return {
                                                                ...user,
                                                                id: user.user_id
                                                            }
                                                        }) || []}
                                                        loading={
                                                            isReadingExtensionsList
                                                        }
                                                        isVisible={
                                                            search?.length > 0 &&
                                                            users?.data?.length > 0
                                                        }
                                                    />
                                                }
                                                isPaginationVisible={
                                                    users?.data?.length > 0
                                                }
                                                paginationProps={{
                                                    boundaryRange: 0,
                                                    activePage:
                                                        listExtensionsFilters.page,
                                                    ellipsisItem: null,
                                                    siblingRange: 2,
                                                    totalPages: Math.ceil(
                                                        users.count / LIMIT
                                                    ),
                                                    onPageChange: async (
                                                        _,
                                                        { activePage }
                                                    ) => {
                                                        setListExtensionsFilters({
                                                            ...listExtensionsFilters,
                                                            page: activePage,
                                                        });
                                                        dispatch(
                                                            pbxConfigActions.getListOfExtensions(
                                                                {
                                                                    page: activePage,
                                                                    limit: LIMIT,
                                                                }
                                                            )
                                                        );
                                                    },
                                                }}
                                            />
                                        );
                                    }}
                                />
                            </Form.Group>
                        )}
                        <Controller
                            name="display_view"
                            control={control}
                            render={({ field: { name, value, onChange } }) => (
                                <Checkbox
                                    checked={value}
                                    onChange={(_, { name, checked }) => {
                                        onChange({
                                            target: { name, value: checked },
                                        });
                                    }}
                                    name={name}
                                    label="Display on Office View"
                                    toggle
                                />
                            )}
                        />
                    </div>
                </Form>
            </Modal.Content>
            <Modal.Actions
                hasSaveButton
                onSave={handleSubmit(!!isEditing ? onEdit : onAdd)}
                saveDisabled={
                    !isValid || !isDirty || errors?.label?.type === "unique"
                }
                saveOptions={{ loading: false }}
            />
        </>
    );
};

const CompanyExtensionModal = ({ open, onClose, onReload, isEditing }) => {
    const [isDirty, setIsDirty] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    return (
        <React.Fragment>

            <Modal open={open} onClose={() => {
                isDirty
                    ? setIsConfirmationOpen(true)
                    : onClose();
            }} size={"small"}>
                <Content
                    onClose={onClose}
                    onReload={onReload}
                    isEditing={isEditing}
                    onDirtyChange={(dirty) => setIsDirty(dirty)}
                />
            </Modal>
            <FullScreenModalPopUp
                header={"Changes not saved"}
                subheader={"Are you sure you want to exit?"}
                isOpen={isConfirmationOpen}
                onConfirm={() => {
                    onClose();
                    setIsConfirmationOpen(false);
                    setIsDirty(false)
                }}
                onFormClose={() => setIsConfirmationOpen(false)}
                closeIcon={false}
            />
        </React.Fragment>
    );
};

export default CompanyExtensionModal;
